import { UserRole } from '@common/interfaces/user'
import { Location } from 'history'
import { IMenuData, ISubMenuData, SIDE_MENU } from './SideMenuConfig'

export const isItemActive = (items: ISubMenuData[], location: Location) =>
  items.map(({ link }) => link).includes(location.pathname)

export const getInitialExpandableListItemsState = (role: UserRole, location: Location) =>
  (SIDE_MENU[role] || []).reduce(
    (acc: { [key: string]: boolean }, { label, subItems }: IMenuData) => {
      if (subItems) {
        acc[label] = isItemActive(subItems, location)
      }

      return acc
    },
    {} as Record<string, boolean>,
  )

export const updateExpandableListItemsState = (
  initialState: { [key: string]: boolean },
  itemToExpand: string,
) => {
  const newExpandableListItemsState: Record<string, boolean> = {}

  for (const key of Object.keys(initialState)) {
    const isListItemExpanded = initialState[itemToExpand]

    if (key === itemToExpand) {
      newExpandableListItemsState[key] = !isListItemExpanded
    } else {
      newExpandableListItemsState[key] = false
    }
  }

  return newExpandableListItemsState
}
